"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSpecies_1 = require("../helpers/getSpecies");
function merge() {
    var streams = Array.prototype.slice.call(arguments);
    var C = getSpecies_1.getSpecies(streams[0]);
    return new C(function (observer) {
        var numObservers = streams.length;
        var subscriptions = streams.map(function (stream) {
            return stream.subscribe({
                next: function (value) {
                    observer.next(value);
                },
                error: function (e) {
                    observer.error(e);
                },
                complete: function () {
                    numObservers -= 1;
                    if (numObservers === 0) {
                        observer.complete();
                    }
                }
            });
        });
        return function () {
            subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
        };
    });
}
exports.merge = merge;
//# sourceMappingURL=merge.js.map